<!--
     <AISuggestion
       :unit="QUnit"
       :action="'ai_action_id'"
     />

     Actions:
     - launch(action) // action={id, name, label, type}
-->

<template>
  <div>
    <ModalDialog
      :title="title"
      :showModalDialog="show"
      clear=""
      message="Mensage1"
      :unit="null"
      :validate="false"
      :loading="is_loading"
      @close-dialog="close_dialog"
      @submit="close_dialog"
      hide_clear_button
      submit_button_text="OK"
    >
      <div slot="modal_content">
        <h1>La "iaia" (Inteligencia Artificial de QmKey)</h1>
        <p>Respuesta generada por IA, puede contener fallos</p>
        <div class="markdown mt-8" ref="answer">Pensando...</div>
        <h2 v-if="error_message">
          {{ "Error: "+error_message }}
        </h2>
      </div>
    </ModalDialog>
  </div>
</template>

<style lang="scss">
  @import '@/sass/markdown.scss';
</style>

<script>
 import { mapGetters } from 'vuex';

 import ModalDialog from './ModalDialog.vue';
 import { ai_render } from '@/utils/ai_render';
 import AIAPI from '@/api/AI';

 export default {
   name: "AISuggestion",

   components: {
     ModalDialog,
   },

   props: {
     unit: {required: true},
     loading: {type: Boolean, default: false},
   },

   data: (() => ({
     show: false,
     internal_loading: false,
     answer: "",
     objects: {}, // {"buttons": {button_id: {"action": "transition", "props": {trans_data}}}}
     action: {},
     error_message: "",
   })),

   computed: {
     ...mapGetters(['centro_id']),

     is_loading() {
       return this.loading || this.internal_loading;
     },

     title() {
       const qunit_title = (this.unit || {}).title || 'Expediente';
       const action_label = (this.action || {}).label || 'Acción IA';
       return `${action_label}: ${qunit_title}`;
     }
   },

   mounted() {
     this.reset_state();
   },

   methods: {
     reset_state() {
       this.show = false;
       this.internal_loading = false;
       this.error_message = "";
       this.answer = "";
     },

     async launch(action) {
       this.action = action
       this.show = true;
       this.internal_loading = true;
       let response = null;
       try {
         response = await AIAPI.action_suggestion(
           this.centro_id,
           action.id,
           this.unit.uid,
         );
       } catch (err) {
         console.warn("AISuggestion error: ", err);
         this.error_message = ''+err;
         this.internal_loading = false;
         return;
       }
       this.internal_loading = false;
       this.answer = response.answer;
       this.objects = response.objects;
     },

     fire_button_action(button_id) {
       const button_props = (this.objects.buttons||{})[button_id] || {};
       if (button_props.action === 'transition') {
         this.fire_transition(button_props.props);
       }
     },

     fire_transition(transition) {
       this.$emit('transition', transition);
     },

     async parse_answer_html() {
       await this.$nextTick();
       const cont = this.$refs.answer;
       const buttons = cont.querySelectorAll('button');

       for (const but of buttons) {
         const but_id = but.getAttribute('data-button-id');
         if (but_id !== undefined) {
           but.onclick = this.fire_button_action.bind(this, but_id);
         }
       }
     },

     close_dialog() {
       this.reset_state();
     },
   },

   watch: {
     answer(val) {
       const html = ai_render(this.answer);
       this.$refs.answer.innerHTML = html;
       this.parse_answer_html();
     },
   },
 };
</script>
